import { useRecoilValue } from "recoil";
import { checkIsBrandSelected, checkOutOfBounds, checkOutOfBoundsUsingPosition, subGeoLevel, getCurrGeoLevelName } from "../../helpers"
import { geoState, selectedTabState } from "../../states";
import { Heading, TypographyColor, TypographyType, Body, BodyType, BodyColor, Button, ButtonTheme, ButtonVariant, ButtonSize } from "../../ui-elements";
import { LuArrowUpRight } from "react-icons/lu";
import { RESET_FIELD_ARRAY } from "../../constants";
import { useSearchParams } from "react-router-dom";

interface BrandPopupProps {
    brand: any;
    selBrands: any[];
    focusedPoi?: any;
    roi: any
    handleClose: (e: any) => void;
    handleNavigation: (e: any, geoLevel: string, geoId: any, geoLevelName: string) => void;
    carousel?: {
        type: 'mbp' | 'poi';
        markers: any[];
        currentIndex: number;
        uniqueKeyField: string;
    } | null;
    onCarouselNext?: () => void;
    onCarouselPrev?: () => void;
}

export const BrandPopup = ({
    brand,
    selBrands,
    focusedPoi,
    roi,
    handleClose,
    handleNavigation,
    carousel,
    onCarouselNext,
    onCarouselPrev
}: BrandPopupProps) => {
    const IS_DECKGL_ENABLED = process.env.REACT_APP_SHOW_DECKGL_LAYER === 'true';
    const selectedGeo = useRecoilValue(geoState);
    const selectedTab = useRecoilValue(selectedTabState);
    const [searchParams] = useSearchParams();
    const catchment = searchParams.get('catchment');

    const handleVisitRegion = (e: any) => {
        const currLevel = getCurrGeoLevelName(selectedGeo);
        let geoLevel = "";

        if (catchment)
            geoLevel = "all";
        else if (currLevel === 'sub_district')
            geoLevel = "village";
        else if (currLevel === 'district')
            geoLevel = selectedTab === 4 ? "sub_district" : "pincode";
        else if (currLevel === 'state')
            geoLevel = "district";

        // For POI, navigate to village level using brand's navigation data
        const navigationData = brand?.navigation || {};
        handleNavigation(e, RESET_FIELD_ARRAY[geoLevel], navigationData, brand?.geoLevel || geoLevel);
    }
      const carouselStyle = {
        backgroundColor: "white",
        position: "absolute" as const,
        bottom: "-25%",
        left: "30%",
        margin: "0 auto",
        borderRadius: "8px",
        width: "45%"
    };

    return (
        <div
            className={`padding-top-bottom-2 brand-popup top-0 left-0 ${checkOutOfBounds({ lat: brand?.latitude, lng: brand?.longitude }, roi).join(" ")}`}
            // onMouseLeave={handleMouseLeave}
            // onClick={(e) => { handleClick(e, brand) }}
            style={{ paddingBottom: "20px" }}

        >
            <div className="d-flex justify-content-between align-items-center w-100">
                <div className="d-flex align-items-center gap-1 p-2">
                    <div className={`presence-indicator-hover-card p-0 m-0 ${checkIsBrandSelected(brand.branchId, selBrands) ? 'selected-poi-highlight' : 'non-selected-poi-highlights'}`}></div>
                    <Heading
                        style={{ fontSize: "12px" }}
                        title={brand?.branchName}
                        colour={TypographyColor.primary}
                        type={TypographyType.h2}
                        classname='m-0 p-0 text-start'
                    />
                </div>
                {focusedPoi.type === 'poi' && focusedPoi?.data?.branchId === brand?.branchId && <span className="material-symbols-outlined fs-16 color-black m-0 p-2 cursor-pointer pe-auto" onClick={(e) => { handleClose(e) }}>close</span>}

            </div>
            <hr className="m-0 p-0 margin-top-1 margin-bottom-1 w-100"/>

            <div className="padding-left-2">
            <Body
                style={{ fontSize: "10px" }}
                type={BodyType.p1}
                color={BodyColor.primary}
                classname="p-0"
            >
                {brand?.subcategory?.length > 0 ? brand?.subcategory?.join(', ') : brand?.subcategory}
            </Body>
              <Body
                style={{ fontSize: "10px" }}
                type={BodyType.p1}
                color={BodyColor.secondary}

                classname="p-0"
            >
                {"Sub-Category"}
            </Body>
            </div>

            <div className="padding-left-2">
            <Body
                style={{ fontSize: "10px" }}
                type={BodyType.p1}
                color={BodyColor.primary}

                classname="p-0"
            >
                {brand?.category}
            </Body>
              <Body
                style={{ fontSize: "10px" }}
                type={BodyType.p1}
                color={BodyColor.secondary}

                classname="p-0"
            >
                {"Category"}
            </Body>
            </div>
                        {focusedPoi.type === 'poi' && focusedPoi?.data?.branchId === brand?.branchId &&
            <hr className="m-0 p-0 margin-top-1 margin-bottom-1 w-100"/>}
            <div className="d-flex align-items-center justify-content-between gap-4 padding-left-right-2 w-100">
                {focusedPoi.type === 'poi' && focusedPoi?.data?.branchId === brand?.branchId &&

                    <a
                        target="_blank"
                        style={{ fontSize: "10px" }}
                        href={brand?.googleMapLink}
                        className="map-anchor-text ff-poppins-medium pe-auto"
                        onClick={(e) => e.stopPropagation()}
                    >
                        Google Map <LuArrowUpRight />
                    </a>}
                {focusedPoi.type === 'poi' && !selectedGeo?.village &&
                    <Button
                        theme={ButtonTheme.primary}
                        variant={ButtonVariant.bordered}
                        size={ButtonSize.xsmall}
                        type="button"
                        classname='fs-12 pe-auto'
                        onClick={(e) => handleVisitRegion(e)}
                    >
                        Visit Village
                    </Button>
                }
            </div>
            {/* Carousel Navigation */}
            {carousel && carousel.markers.length > 1 && focusedPoi.type === 'poi' && focusedPoi?.data?.branchId === brand?.branchId && (
                <div className="d-flex align-items-center justify-content-center gap-1 p-0 m-0" style={carouselStyle}>
                    <Button
                        theme={ButtonTheme.primary}
                        variant={ButtonVariant.transparent}
                        type='button'
                        disabled={carousel.currentIndex === 0}
                        onClick={(e) => {
                            e.stopPropagation();
                            onCarouselPrev && onCarouselPrev();
                        }}
                        classname='p-0 m-0 h-auto w-auto pe-auto'
                    >
                        <span className="material-symbols-outlined fs-16 p-0 m-0 padding-top-2">keyboard_arrow_left</span>
                    </Button>
                    <Heading
                        title={`${carousel.currentIndex + 1} of ${carousel.markers.length}`}
                        type={TypographyType.h7}
                        colour={TypographyColor.primary}
                        classname='m-0 p-0'
                    />
                    <Button
                        theme={ButtonTheme.primary}
                        variant={ButtonVariant.transparent}
                        type='button'
                        disabled={carousel.markers.length === carousel.currentIndex + 1}
                        onClick={(e) => {
                            e.stopPropagation();
                            onCarouselNext && onCarouselNext();
                        }}
                        classname='p-0 h-auto w-auto pe-auto'
                    >
                        <span className="material-symbols-outlined fs-16 p-0 m-0 padding-top-2">keyboard_arrow_right</span>
                    </Button>
                </div>
            )}
        </div>
    )
}